import { OrganizationCodes } from '@revenuemarket/bank';
import qs from 'qs';

import { API } from '~apis/axios/instance';
import { BalanceList } from '~apis/dashboard';
import { ResponseBaseWithData } from '~types/response';

export interface ExchangeRateInfo {
  currency: string;
  date: string;
  rate: number;
}

export interface HomeDashboardResponse {
  totalBalance: ITotalBalance;
  corporateCardApprovalSummary: ICorporateCardApprovalSummary;
  taxInvoiceSummary: ITaxInvoiceSummary;
  cashReceiptSummary: ICashReceiptSummary;
  cashflow: ICashflow;
}
interface ITotalBalance {
  balances: BalanceList;
  exchangeRates?: ExchangeRateInfo[];
}

export enum CardScrapingStatus {
  INIT = 'INIT',
  ENQUEUED = 'ENQUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

interface ICashReceiptSummary {
  sales: ICashReceiptSummaryItem;
  purchases: ICashReceiptSummaryItem;
}
interface ICashReceiptSummaryItem {
  totalAmountSum: number;
  supplyAmountSum: number;
  vatAmountSum: number;
  totalTipAmount: number;
  totalCount: number;
}
interface ICorporateCardApprovalSummary {
  usedAmountByOrganizations: IUsedAmountByOrganizationsItem[];
  totalUsedAmount: number;
}
interface IUsedAmountByOrganizationsItem {
  delta: number;
  organizationCode: OrganizationCodes;
  usedAmountByCard: IUsedAmountByCardItem[];
  totalUsedAmount: number;
  scrapingStatus: CardScrapingStatus;
}
export interface IUsedAmountByCardItem {
  cardNo: string;
  usedAmount: number;
  userNames: string[];
  aliasNames: string[];
}
interface ITaxInvoiceSummary {
  sales: ISales;
  purchases: IPurchases;
}
interface ISales {
  type: string;
  totalSupplyAmount: number;
  totalVatAmount: number;
  totalAmount: number;
  totalCount: number;
}
interface IPurchases {
  type: string;
  totalSupplyAmount: number;
  totalVatAmount: number;
  totalAmount: number;
  totalCount: number;
}
interface ICashflow {
  inflowTransactionAmount: number;
  outflowTransactionAmount: number;
}

export const getHomeDashboard = ({
  companyId,
  startDate,
  endDate,
}: {
  companyId: string;
  startDate?: string;
  endDate?: string;
}) => {
  const queryString = qs.stringify({
    startDate,
    endDate,
  });
  return API.get<ResponseBaseWithData<HomeDashboardResponse>>(
    `/api/v3/companies/${companyId}/home-dashboard${queryString ? `?${queryString}` : ''}`,
  );
};
